module.exports = __webpack_public_path__ + "static/media/sort-unselected.90cd5f85.svg";